export default function pageNavigation(pageTitle, navigate) {
    if (pageTitle == "/") {
        navigate("/");
    }
}
